import $ from "jquery";
import Formatter from "@rmlibrary/formatting";

const formatter = new Formatter();
const storageKeyPrefix = "ca.dynamic.calculators.";

function getDateRangeFromDate(date, range) {
    let [month, year] = date.split("/");
    year = Number(year);
    let endDate = new Date(`${month}/01/${year}`);
    const startDateMonth = month - 1 < 1 ? 12 : month - 1;
    let startDate = new Date(`${startDateMonth}/01/${year - range}`);
    endDate = formatter
        .formatDate(endDate, "mmm yyyy")
        .replace(/June/g, "Jun")
        .replace(/July/g, "Jul")
        .replace(/1éc/g, "déc");
    startDate = formatter
        .formatDate(startDate, "mmm yyyy")
        .replace(/June/g, "Jun")
        .replace(/July/g, "Jul")
        .replace(/1éc/g, "déc");

    return `${startDate} - ${endDate}`;
}

function getNoDayDateFromDate(date) {
    let [month, year] = date.split("/");
    year = Number(year);
    let formattedDate = new Date(`${month}/01/${year}`);
    formattedDate = formatter.formatDate(formattedDate, "mmm yyyy").replace(/June/g, "Jun").replace(/July/g, "Jul");

    return formattedDate;
}

function getRGBFromHex(hex) {
    const rgb = hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)
        .substring(1)
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16))
        .join(",");

    return `rgb(${rgb})`;
}

function getValue(object, path) {
    function getResult(separator) {
        return path
            .split(separator)
            .filter((part) => part)
            .reduce((result, part) => (result !== null && result !== undefined ? result[part] : result), object);
    }

    if (!path) {
        return null;
    }

    const result = getResult(/[,[\]]+?/) || getResult(/[,[\].]+?/);
    return result === undefined || result === object ? null : result;
}

function outputAttribute(name, inputs, callback) {
    $(".print-page-wrapper, rm-html-pdf")
        .find(`[${name}]`)
        .each((i, element) => {
            const path = $(element).attr(name);
            const value = getValue(inputs, path);
            callback(element, value);
        });
}

function buildTranscriptHTML(descriptions) {
    return () =>
        descriptions.map((description) => {
            const paragraph = document.createElement("p");
            paragraph.innerText = description;

            return paragraph;
        });
}

function formatPortfolioAns(portfolio) {
    if (portfolio === "maximumGrowth") {
        if (getLanguage() === "fr") {
            return "de croissance maximale";
        } else {
            return "Maximum Growth";
        }
    } else if (portfolio === "growth") {
        if (getLanguage() === "fr") {
            return "de croissance";
        } else {
            return "Growth";
        }
    } else if (portfolio === "balanced") {
        if (getLanguage() === "fr") {
            return "équilibré";
        } else {
            return "Balanced";
        }
    }
}

function generatePDF(inputs) {
    const currentDate = new Date();

    inputs = {
        ...inputs,
        currentDate
    };

    outputAttribute("data-alt", inputs, (element, value) => $(element).attr("alt", value));

    outputAttribute("data-colour", inputs, (element, value) => {
        if (value.indexOf("#") > -1) {
            value = getRGBFromHex(value);
        }

        $(element).css("background-color", value);
    });

    outputAttribute("data-if", inputs, (element, value) => {
        if (!value) {
            $(element).hide();
        }
    });

    outputAttribute("data-src", inputs, (element, value) => {
        if (value) {
            const base = $(element).attr("data-src-base") || "";
            if ($(element).css("visibility") === "hidden") {
                $(element).one("load", () => $(element).css("visibility", "visible"));
            }
            $(element).attr("src", `${base}${value}`);
        }
    });

    outputAttribute("data-output-currency", inputs, (element, value) => {
        try {
            let decimals = $(element).attr("data-output-decimals");
            if (decimals === "auto") {
                decimals = value % 1 !== 0 ? 2 : 0;
            } else {
                decimals = Number($(element).attr("data-output-decimals")) || 0;
            }

            $(element).text(formatter.formatCurrency(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-date", inputs, (element, value) => {
        try {
            const type = $(element).attr("data-output-type");

            if (type === "noDay") {
                $(element).text(getNoDayDateFromDate(value));
            } else if (type === "range") {
                let range = $(element).attr("data-output-range");
                range = getValue(inputs, range) || 1;

                $(element).text(getDateRangeFromDate(value, range));
            } else {
                const format = getLanguage() === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";

                $(element).text(formatter.formatDate(value, format));
            }
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-number", inputs, (element, value) => {
        try {
            const decimals = Number($(element).attr("data-output-decimals")) || 0;

            $(element).text(formatter.formatNumber(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-percentage", inputs, (element, value) => {
        try {
            const decimals = Number($(element).attr("data-output-decimals")) || 0;
            const inputType = $(element).attr("data-input-type") || "percent";

            if (inputType === "decimal") {
                value *= 100;
            }

            $(element).text(formatter.formatPercentage(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-text", inputs, (element, value) => {
        let textValue = value ? value.toString() : "";
        const lineBreakCharacter = $(element).attr("data-output-line-break-character") || "";
        if (textValue && lineBreakCharacter) {
            const characterIndex = textValue.indexOf(lineBreakCharacter);
            if (characterIndex > -1) {
                textValue = `${textValue.slice(0, characterIndex)}<br />${textValue.slice(characterIndex)}`;
            }
        }

        $(element).html(textValue);
        $(element).css("visibility", "visible");
    });
}

function getLanguage() {
    return document.documentElement.lang.toLowerCase().indexOf("en") > -1 ? "en" : "fr";
}

function isChrome() {
    return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
}

function isSafari() {
    return (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));
}

function retrieveFromStorage(page) {
    const storageKey = `${storageKeyPrefix}${page}`;

    return JSON.parse(sessionStorage.getItem(storageKey));
}

function saveToStorage(page, value) {
    const storageKey = `${storageKeyPrefix}${page}`;

    sessionStorage.setItem(storageKey, JSON.stringify(value));
}

function startsWithFrenchVowel(name) {
    const regex = new RegExp(/([AaÀàÂâÄäEeÉéÈèIiÎîOoÖöÔôUuYy])+/);

    return regex.test(name[0]);
}

export {
    buildTranscriptHTML,
    formatPortfolioAns,
    generatePDF,
    getLanguage,
    isChrome,
    isSafari,
    retrieveFromStorage,
    saveToStorage,
    startsWithFrenchVowel
};
